export default "__VITE_ASSET__74b436a1__"